import { render, staticRenderFns } from "./main.vue?vue&type=template&id=1fa84426&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=1fa84426&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseHeader: require('/opt/airport.kg/src/components/base/header/index.vue').default,AffiliatorSale: require('/opt/airport.kg/src/components/affiliator/sale.vue').default,ServiceMainList: require('/opt/airport.kg/src/components/service/main/list.vue').default,IconArrowLong: require('/opt/airport.kg/src/components/icon/arrow-long.vue').default,RzButton: require('/opt/airport.kg/node_modules/razlet-ui/src/components/button/index.js').default,RzContainer: require('/opt/airport.kg/node_modules/razlet-ui/src/components/container/index.vue').default})
